import React from 'react';
import { useTranslation } from 'react-i18next';

type ConfirmationModalProps = {
    onConfirm: () => void;
    onCancel: () => void;
    message: string;
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ onConfirm, onCancel, message }) => {
    const { t } = useTranslation();

    return (
        <div className="rounded-lg bg-white p-6">
            <p className="mb-4 text-lg">{message}</p>
            <div className="flex justify-end space-x-4">
                <button
                    onClick={onCancel}
                    className="rounded border border-gray-300 px-4 py-2 text-gray-600 hover:bg-gray-100"
                >
                    {t('common:cancel', 'Cancel')}
                </button>
                <button
                    onClick={onConfirm}
                    className="rounded bg-red-600 px-4 py-2 text-white hover:bg-red-700"
                >
                    {t('common:confirm', 'Confirm')}
                </button>
            </div>
        </div>
    );
};

export default ConfirmationModal;
